import {LovValueSummary} from "../../../modules/common/lov/lov-value/api/model/lovValueSummary.model";
import {PartnerSummaryModel} from "../../../modules/partner/common/api/model/partnerSummary.model";

export class MarketingChannelSummaryModel {
    id: number;
    channelPartner: PartnerSummaryModel;
    partner: PartnerSummaryModel;
    type: LovValueSummary;
    channelPartnerType: LovValueSummary;
}

export enum MarketingChannelTypes {
    CHANNEL_PARTNER_TYPE_VALUE = 'MARKETING_CHANNEL_PARTNER'
}